import { useState } from 'react'
import { stockLabel } from './medicationFormat'

function MedicationStockButton({ disabled, onReload }) {
  const [open, setOpen] = useState(false)
  const [quantity, setQuantity] = useState('30')

  if (!open) {
    return (
      <button type="button" className="patients-btn patients-btn--ghost patients-btn--compact" onClick={() => setOpen(true)} disabled={disabled}>
        + Recarregar estoque
      </button>
    )
  }

  return (
    <form
      className="med-stock-form"
      onSubmit={(event) => {
        event.preventDefault()
        const value = Number(quantity)
        if (!Number.isFinite(value) || value <= 0) return
        onReload(value)
        setOpen(false)
      }}
    >
      <input
        type="number"
        min="1"
        step="1"
        value={quantity}
        aria-label="Quantidade comprada"
        onChange={(event) => setQuantity(event.target.value)}
      />
      <button type="submit" className="patients-btn patients-btn--primary patients-btn--compact">Somar</button>
      <button
        type="button"
        className="patients-btn patients-btn--ghost patients-btn--compact"
        onClick={() => { setOpen(false); setQuantity('30') }}
      >
        Cancelar
      </button>
    </form>
  )
}

export function StockBadge({ item }) {
  const level = item.stock_level || 'ok'
  const label = level === 'empty' ? 'Sem estoque' : level === 'low' ? 'Estoque baixo / Comprar mais' : null
  return (
    <span className={`med-stock${level === 'low' ? ' is-low' : ''}${level === 'empty' ? ' is-empty' : ''}`}>
      {`${stockLabel(item)}${label ? ` · ${label}` : ''}`}
    </span>
  )
}

export default MedicationStockButton
